import { ComponentPropsWithoutRef, FC } from 'react';

type StatusWarningIconProps = ComponentPropsWithoutRef<'svg'>;

export const StatusWarningIcon: FC<StatusWarningIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_79_6812)">
                <path
                    d="M-0.0600433 14.4319L8 1.06897L16.06 14.4319H-0.0600433ZM1.72996 13.4327H14.27L8 2.98399L1.72996 13.4327ZM7.99341 12.2556C8.15218 12.2556 8.28565 12.2037 8.39381 12.0999C8.50199 11.9962 8.55608 11.8649 8.55608 11.7061C8.55608 11.5474 8.50419 11.4139 8.40039 11.3057C8.29662 11.1975 8.16535 11.1434 8.00658 11.1434C7.84782 11.1434 7.71435 11.1953 7.60619 11.2991C7.49801 11.4029 7.44392 11.5342 7.44392 11.6929C7.44392 11.8517 7.49581 11.9852 7.5996 12.0933C7.70338 12.2015 7.83465 12.2556 7.99341 12.2556ZM7.50883 10.1603H8.508V6.21076H7.50883V10.1603Z"
                    fill={fill ?? 'currentColor'}
                />
            </g>
        </svg>
    );
};
